import { useTranslation } from "react-i18next";
import { InlineSwitcher } from "components/common/InlineSwitcher";
import { KIND_LABEL_KEY } from "../../QuantitiesTab/constants";
import { VisualDiffLegend } from "../VisualDiffLegend";
import { KIND_TO_QUANTITY_KIND } from "../constants";
import type { VisualDiffKind } from "../../utils/computeVisualDiff";
import type { VisualDiffToolbarProps } from "./types";

export const VisualDiffToolbar = ({
  activeKind,
  onKindChange,
  countsByStatus,
  visibleStatuses,
  onStatusToggle,
}: VisualDiffToolbarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <InlineSwitcher<VisualDiffKind>
        value={activeKind}
        onChange={onKindChange}
        variant="segmented"
        className="w-full max-w-xs lg:w-56 lg:max-w-none"
        listClassName="text-sm"
        options={[
          {
            value: "elements",
            label: t(KIND_LABEL_KEY[KIND_TO_QUANTITY_KIND.elements]),
          },
          {
            value: "trays",
            label: t(KIND_LABEL_KEY[KIND_TO_QUANTITY_KIND.trays]),
          },
        ]}
      />
      <VisualDiffLegend
        countsByStatus={countsByStatus}
        visibleStatuses={visibleStatuses}
        kind={activeKind}
        onStatusToggle={onStatusToggle}
      />
    </div>
  );
};
